/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import fileDownloadHandler from "helper/DownloadFile";
import { useTranslation } from "react-i18next";

const ConversationMailPopup = ({ selectedMailId, resetMailId }) => {
  const token = localStorage.getItem("token");

  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [senderEmail, setsenderEmail] = useState("");
  const [senderName, setSenderName] = useState("");
  const [recieverEmail, setrecieverEmail] = useState("");
  const [mailSubject, setmailSubject] = useState("");
  const [mailDate, setmailDate] = useState("");
  const [mailTime, setmailTime] = useState("");
  const [mailDescription, setmailDescription] = useState("");
  const [mailUploads, setmailUploads] = useState([]);
  const [mailTransport, setMailTransport] = useState(null);
  const [mailTransportResponse, setMailTransportResponse] = useState(null);
  const [emailSendingMethod, setEmailSendingMethod] = useState("");


  // Format date to dd/mm/yy h:m:s
  const formatDeliveryDate = (dateString) => {
    if (!dateString) return "";
    
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  // Extract response message from response object or string
  const getResponseMessage = (response) => {
    if (!response) return "";
    
    // If response is a string, return it
    if (typeof response === "string") return response;
    
    // If response is an object, try to extract the message
    if (typeof response === "object") {
      return response.message || response.response || JSON.stringify(response);
    }
    
    return String(response);
  };

  const getMailDetails = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_MAIL_DETAILS}/${selectedMailId}?token=${token}`;

      const response = await getData(requestUrl);

      console.log('Mail Details Response',response);

      if (response.status) {
        setmailSubject(response.data.subject);
        setsenderEmail(response.data.sendermail);
        setSenderName(response.data.sendername || "");
        setrecieverEmail(response.data.receivermail);
        setmailDate(response.data.maildate);
        setmailTime(response.data.mailtime);
        setmailDescription(response.data.description);
        setmailUploads(
          response.data.uploads.map(({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          }))
        );
        setMailTransport(response.data.mailtransport || null);
        setMailTransportResponse(response.data.mailtransportresponse || null);
        setEmailSendingMethod(response.data.emailsendingmethod || "");

        if (
          response.data.receivermail.toString() === userInfo.email.toString() &&
          response.data.mailopened === false
        ) {
          setTimeout(() => {
            updateMailTracker();
          }, 1000);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for update mail
  const updateMailTracker = async () => {
    try {
      const mailData = {
        mailopened: true,
        tracker: "2",
      };

      let requestUrl = `${url.API_BASE_URL}${url.API_UPDATE_MAIL}/${selectedMailId}?token=${token}`;

      await putData(requestUrl, mailData);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (selectedMailId) {
      getMailDetails();
    }
  }, [selectedMailId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="offcanvasEmail"
      aria-labelledby="offcanvasEmailLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              mail
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasEmailLabel"
            >
              {mailSubject}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("View conversation details")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetMailId}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                  {t("Mail Details")}
                </label>
                <ul className="list-unstyled">
                  <li className="d-flex gap-3 mb-2 align-items-center">
                    <span
                      className="avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: 32, height: 32 }}
                    >
                      <span className="material-symbols-outlined">person</span>
                    </span>
                    <span
                      className="d-block text-gray fw-medium"
                      style={{ minWidth: "60px" }}
                    >
                      {t("From")}
                    </span>
                    <div className="d-flex flex-column">
                      {senderName ? (
                        <>
                          <span className="text-dark fw-semibold">{senderName}</span>
                          <Link
                            to={`mailto:${senderEmail}`}
                            className="text-primary fs-sm"
                            title={senderEmail}
                            style={{ textDecoration: "underline" }}
                          >
                            {`<${senderEmail}>`}
                          </Link>
                        </>
                      ) : (
                        <Link
                          to={`mailto:${senderEmail}`}
                          className="text-primary fw-semibold"
                          title={senderEmail}
                          style={{ textDecoration: "underline" }}
                        >
                          {senderEmail}
                        </Link>
                      )}
                    </div>
                  </li>
                  <li className="d-flex gap-3 mb-2 align-items-center">
                    <span
                      className="avatar bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: 32, height: 32 }}
                    >
                      <span className="material-symbols-outlined">person</span>
                    </span>
                    <span
                      className="d-block text-gray fw-medium"
                      style={{ minWidth: "60px" }}
                    >
                      {t("To")}
                    </span>
                    <Link
                      to={`mailto:${recieverEmail}`}
                      className="d-block text-primary fw-semibold"
                      title={recieverEmail}
                      style={{ textDecoration: "underline" }}
                    >
                      {recieverEmail}
                    </Link>
                  </li>
                  <li className="d-flex gap-3 align-items-center">
                    <span
                      className="d-block text-gray fw-medium"
                      style={{ minWidth: "60px" }}
                    >
                      {t("Time")}
                    </span>
                    <p className="mb-0">
                      <span className="date fw-semibold">{mailDate}</span>{" "}
                      <span className="text-gray">at</span>{" "}
                      <span className="time fw-semibold">{mailTime}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                  {t("Description")}
                </label>
                <p dangerouslySetInnerHTML={{ __html: mailDescription }}></p>
              </div>
              {mailTransportResponse && (
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    {t("Delivery Status")}
                  </label>
                  <div className="delivery-status">
                    {mailTransportResponse.delivery === true ? (
                      <>
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span className="material-symbols-outlined text-success" style={{ fontSize: "20px" }}>
                            check_circle
                          </span>
                          <span className="text-success fw-medium">
                            {getResponseMessage(mailTransportResponse.response)}
                          </span>
                        </div>
                        {mailTransportResponse.sentAt && (
                          <div className="text-muted fs-sm" style={{ paddingLeft: "28px" }}>
                            {t("Sent at")}: {formatDeliveryDate(mailTransportResponse.sentAt)}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span className="material-symbols-outlined text-danger" style={{ fontSize: "20px" }}>
                            error
                          </span>
                          <span className="text-danger fw-medium">
                            {getResponseMessage(mailTransportResponse.response)}
                          </span>
                        </div>
                        {mailTransportResponse.sentAt && (
                          <div className="text-muted fs-sm" style={{ paddingLeft: "28px" }}>
                            {t("Attempted at")}: {formatDeliveryDate(mailTransportResponse.sentAt)}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
              {mailUploads.length > 0 && (
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    {t("Attachments")}
                  </label>
                  <ul className="documents d-flex flex-wrap gap-3 mt-3 list-unstyled">
                    {mailUploads.map((doc, index) => (
                      <li
                        className="document d-flex align-items-center px-3 py-2 body-bg rounded-10 shadow-sm"
                        key={index}
                        style={{
                          transition: "box-shadow 0.2s",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.boxShadow =
                            "0 0 0 2px #0d6efd")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.boxShadow = "")
                        }
                      >
                        <img
                          src={
                            doc.path.split(".").pop() === "pdf"
                              ? assetImages.PdfImg
                              : assetImages.DocImg
                          }
                          alt={doc.name}
                          className="img-fluid me-2"
                          style={{ width: 28, height: 28 }}
                        />
                        <span
                          className="d-block fw-medium me-4"
                          title={doc.name}
                          style={{
                            maxWidth: 120,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {doc.name}
                        </span>
                        <Link
                          to="#"
                          onClick={() => fileDownloadHandler(doc)}
                          title={t("Download")}
                          className="ms-auto"
                        >
                          <span
                            className="d-block material-symbols-outlined icon-lg text-primary"
                            style={{ fontSize: 24 }}
                          >
                            download
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {mailTransport && mailTransport.config && (
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    {t("Mail Transport Configuration")}
                  </label>
                  <div className="transport-config">
                    {emailSendingMethod && (
                      <div className="mb-3">
                        <span className="text-normal">
                          {emailSendingMethod === "owner_smtp" 
                            ? t("Mail sent using Component Owner's SMTP") + " - " + (senderName || senderEmail)
                            : t("Mail sent using Sender's SMTP") + " - " + (senderName || senderEmail)
                          }
                        </span>
                      </div>
                    )}
                    <ul className="list-unstyled mb-0">
                      {mailTransport.service && (
                        <li className="d-flex gap-2 mb-2">
                          <span className="text-gray fw-medium" style={{ minWidth: "80px" }}>
                            {t("Service")}:
                          </span>
                          <span className="text-dark">{mailTransport.service}</span>
                        </li>
                      )}
                      {mailTransport.config.host && (
                        <li className="d-flex gap-2 mb-2">
                          <span className="text-gray fw-medium" style={{ minWidth: "80px" }}>
                            {t("Host")}:
                          </span>
                          <span className="text-dark">{mailTransport.config.host}</span>
                        </li>
                      )}
                      {mailTransport.config.user && (
                        <li className="d-flex gap-2 mb-2">
                          <span className="text-gray fw-medium" style={{ minWidth: "80px" }}>
                            {t("User")}:
                          </span>
                          <span className="text-dark">{mailTransport.config.user}</span>
                        </li>
                      )}
                      {mailTransport.config.port && (
                        <li className="d-flex gap-2 mb-2">
                          <span className="text-gray fw-medium" style={{ minWidth: "80px" }}>
                            {t("Port")}:
                          </span>
                          <span className="text-dark">{mailTransport.config.port}</span>
                        </li>
                      )}
                      {mailTransport.config.secure !== undefined && (
                        <li className="d-flex gap-2">
                          <span className="text-gray fw-medium" style={{ minWidth: "80px" }}>
                            {t("Secure")}:
                          </span>
                          <span className={mailTransport.config.secure ? "text-success" : "text-warning"}>
                            {mailTransport.config.secure ? t("Yes") : t("No")}
                          </span>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}
            </div>
            {/* email-footer removed as requested */}
          </form>
        </div>
      </div>
    </div>
  );
};
// CollapsibleDescription removed as requested

export default ConversationMailPopup;
